import layout from './layouts/Main.vue'
import GlobalMixin from '@/app/shared/mixins/global';
import BaseGestaoMixin from '@/app/shared/mixins/BaseGestaoMixin';
import ModuleMixin from './shared/mixins/ModuleMixin';
import ManageStoreMixin from './shared/mixins/ManageStoreMixin';

export default {
    mixins: [
        GlobalMixin,
        BaseGestaoMixin,
        ModuleMixin,
        ManageStoreMixin,
    ],
    components: {
        layoutGestao: layout,
    },
    data() {
        return {
            pageID: null,
            list: [],
            table: {
                addParamsToUrl: true,
                loadingMsg: 'Loading...',
                notFoundMsg: 'Sem resultados',
                orderByTemplate: 'Ordenar por {field}',
                autoUpdateFilter: true,
                autoUpdateExternalFilter: false,
                settings: {},
                columns: [],
                filters: {
                    q: '',
                },
            },
            query: '',
            queryParams: {
                filters: 'filter',
            },
            form: {
                id: null
            },
            help: {
                title: 'Cada planta impressa, é constituida por 1 ou mais mapas. Desta forma, em cada Mapa será configurada a escala, as camadas (layers), os títulos, e toda a informação configurável no template de impressão',
                name: 'Nome identificativo para este mapa',
                status: 'Permite ativar/desativar o mapa',
                page_title: 'Título da página de impressão',
                div_title: 'Sub-título da página de impressão',
                map_title: 'Título identificativo do tema da aplicação (mapa) impresso (se aplicável)',
                comment: 'Caso opte por definir o comentário directamente no layout de impressão, deve deixar este campo vazio',
                dpi: 'Resolução em dpi para impressão',
                crs: '<a href="https://epsg.org" target="_blank">Código EPSG</a> - Sistemas de referência de coordenadas (CRS)',
                scale: 'Se não for definida escala, será feito o <strong>fit</strong> à implantação do edifício',
                placeholderResource: 'Pesquisar Tema...',
                no_abstract: 'No abstract provided',
                resources_title: 'Temas adicionados',
                crossresources_title: 'Temas para cruzamento',
                maps_title: 'Mapas adicionados',
            },
        }
    },
}